import { Component, ComponentInterface, h, Element, State, Prop } from '@stencil/core';
import { guid } from 'utils';

declare const assetPath;

@Component({
	tag: 'kdx-team-card',
	styleUrl: 'kdx-team-card.scss',
	shadow: false,
})
export class StTeamCard implements ComponentInterface {

	@Element() root: HTMLElement;

	@State() guid: string = guid();
	@State() links: Array<any> = [];

	@Prop() classes: string;
	@Prop() imgSrc: string;
	@Prop() imgAlt: string;

	componentDidRender() {
		globalThis.imageLoader?.initialize();			
	}

	render() {
		return (
		<div class={`kdx-team-card card ${this.classes ?? ''}`}>
			{(this.imgSrc) && (
			<div class="card-img-top">
				{(this.imgSrc) ? (
					<div
						class="card-img lazy-load-bg"
						style={{ backgroundImage: `url(${this.imgSrc})` }}
						role="img"
						title={this.imgAlt}
						aria-describedby={this.imgAlt}>
					</div>
				) : (
					<div
						class="card-img lazy-load-bg"
						style={{ backgroundImage: `url(${assetPath}/img/logo-bg-repeater-blk@2x.png)` }}
						role="presentation"
						aria-label={this.imgAlt}>
					</div>
				)}
			</div>
			)}
			<div class="card-content">
				<div class="card-body detail-bio">
					<slot />
				</div>
			</div>
		</div>
		);
	}

}
